<template>
	<div>
		<div class="int-head">
			<div class="travel-header">
				<div class="travel-conpany-name" v-if="AccountInfo != ''">
					<div class="head-box fl">
						<img
							id="logo"
							:src="AccountInfo.CompanyLogo"
							onerror="javascript: this.src = 'https://img2.yiqifei.com/20150810/3686cfe8b06347a79c5867fc99abee49.png!80';"
						/>
					</div>
					<div class="head-name ml10 fl mt15">{{ AccountInfo.CompanyName }}</div>
				</div>

				<div class="code-box6">
					<el-row type="flex">
						<img :src="require('../assets/indexPhone.jpg')" style="width:22px;height:35px;margin-top:5px;margin-right:10px" />
						<el-dropdown>
							<div>
								<div><span>扫一扫</span></div>
								<div>
									易起飞小程序
									<span class="iconfont icon-xiangxia2"></span>
								</div>
							</div>
							<el-dropdown-menu slot="dropdown" style="padding:10px">
								<div>
									<img src="http://3gapitest.yiqifei.com/WXMiniAppApi/GetWXacode?mpid=26&path=/pages/index/index" style="width:120px;height:120px" />
									<div style="text-align:center" class="visitor-phone">手机扫描快速访问</div>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</el-row>
				</div>
				<div class="service-phone-box">
					<div class="service-item">
						<el-row type="flex" align="middle">
							<img src="../assets/feihuo-phone.png" alt="" />

							<div class="phone-number ml10">
								<div class="ft14 gray6">24h客户服务电话</div>
								<div class="s-phone">400-678-6633</div>
							</div>
						</el-row>
					</div>
					<div class="i-block cursor" style="top:-7px;left:6px;" @click="bindNoticeCenter">
						<span class="iconfont icon-tongzhi"></span>
						<span class="xiaoxi-num" v-if="noticeCount != ''">{{ noticeCount }}</span>
					</div>
				</div>

				<div class="nav-right-box" v-if="AccountInfo != ''">
					<div class="travel-admin">
						<div class="head-img fl">
							<router-link to="/Profile/Account"><img :src="AccountInfo.UserHeadImg" /></router-link>
							<!-- <a href="/Profile/Account"><img :src="AccountInfo.UserHeadImg" /></a> -->
						</div>
						<div role="presentation" class="dropdown head-name2">
							<router-link to="/Profile/Account" class="dropdown-toggle iconfont icon-xiangxia2" href="/Profile/Account" role="button">
								<span class="name">{{ AccountInfo.Name }}</span>
								<span class="caret"></span>
							</router-link>
							<ul class="dropdown-menu person-box">
								<li>
									<router-link to="/Profile/Account">
										<span class="iconfont icon-jiaoseguanli icon-sec fl"></span>
										{{ AccountInfo.RoleName }}
									</router-link>
								</li>
								<li>
									<a @click="logout" href="javascript:;">
										<span class="iconfont icon-tuichu icon-quit"></span>
										退出
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="int-nav-header">
			<el-row class="int-nav" justify="space-between" type="flex">
				<router-link
					v-for="(item, index) in headNavs"
					:key="index"
					:to="item.link"
					:class="item.link == '/' + $store.state.routerName ? 'current' : ''"
					@click.native="logo"
				>
					{{ item.name }}
				</router-link>
			</el-row>
		</div>
		<!-- <el-row type="flex" class="gonggao-advisor" align="middle" justify="center" v-if="NoticeText!=''">
			<el-row type="flex" class="gonggao-v">
				<div style="width:100px;font-weight: bold;">
					<span class="iconfont icon-gonggao"></span>
					<span>最新公告:</span>
				</div>
				<el-carousel height="30px" direction="vertical" :autoplay="true" style="width:1000px" indicator-position="none" interval="3000">
					<el-carousel-item v-for="item in 3" :key="item"><div class="advisor-text">{{NoticeText}}</div></el-carousel-item>
				</el-carousel>
			</el-row>
		</el-row> -->
	</div>
</template>

<script>
import { getAccountInfo, setAccountInfo,clearLoginInfo } from '@/utils/localdatas';
import { GetHeadNav, GetMessageList, GetNotice } from '@/api/memberApi';

import Vuex from 'vuex';
var that;
export default {
	name: 'Header',
	props: {
		msg: String,
		inputValue: String
	},
	setup(props) {
		console.log(props.inputValue);
	},
	watch() {
		that.path = this.$store.state.routerName;
		console.log(1);
	},
	data() {
		return {
			AccountInfo: '',
			returnurl: '/',
			path: '',
			headNavs: [
				 { name: '首页', link: '/' },
				 { name: '全球机票', link: '/IntlAir' },
				// // { name: '国内机票', link: '/DomesticAir' },
				 { name: '全球酒店', link: '/Hotel' },
				{ name: '火车票', link: '/Train' },
				// { name: '欧铁', link: '/Europe' },
				 { name: '保险', link: '/Insurance' },
				// { name: '团票', link: '/TuanPiaoBao' },
				 { name: '个人中心', link: '/Profile/Order' },
				{ name: '系统管理', link: '/Management/Organization' }
			],
			noticeCount: '',
			NoticeText: ''
		};
	},
	created(props) {
		//生命周期里接收参数
		that = this;

		let accountInfo = getAccountInfo();
		if (accountInfo != null) {
			that.AccountInfo = accountInfo;
			getMessageList(accountInfo.Account);
		} else {
			that.$router.push({
				path: '/login',
				query: {
					logout: true,
					returnurl: that.$route.path
				}
			});
		}
		console.log(that.path);
		console.log(that.AccountInfo);
		getHeadNav();
		getNotice();
	},
	methods: {
		bindNoticeCenter(e) {
			that.$router.push({
				path: '/Profile/NoticeCenter'
			});
		},
		logout(e) {
			console.log(that.$route.path);
			clearLoginInfo();
			that.$router.push({
				path: '/login',
				query: {
					logout: true,
					returnurl: that.$route.path
				}
			});
		},
		logo() {
			console.log(1111);
			console.log(that.$route);
			var path = that.$route.path;
			that.path = this.$store.state.routerName;
			console.log(that.path + '44444');
			console.log(this.$store.state.routerName);
		}
	}
};
function getHeadNav(accountno) {
	GetHeadNav(null, function(result) {
		if (result.code == 0) {
			that.headNavs = result.data.headNavs;
		}
	});
}
function getMessageList(accountno) {
	let parm = {
		accountno: accountno
		// accountno: 'CMC0K38F',
		// pageindex:that.pageindex
	};
	GetMessageList(parm, function(result) {
		if (result.code == 0) {
			that.noticeCount = result.data.pageCount;
			if (that.noticeCount > 99) {
				that.noticeCount = '99+';
			}
		}
	});
}
function getNotice(accountno) {
	GetNotice(null, function(result) {
		if (result.code == 0) {
			that.NoticeText = result.data.NoticeText;
		}
	});
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
